/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40IDUuNDk5OTlMOC4wMDAwMSAzLjA4OTk5TDUuNjAwMDEgNS40OTk5OUw0Ljg5MDAxIDQuNzg5OTlMOC4wMDAwMSAxLjY3OTk5TDExLjExIDQuNzg5OTlMMTAuNCA1LjQ5OTk5Wk01LjYwMDAxIDEwLjUxTDguMDAwMDEgMTIuOTFMMTAuNCAxMC41MUwxMS4xMSAxMS4yMUw4LjAwMDAxIDE0LjMyTDQuODkwMDEgMTEuMjFMNS42MDAwMSAxMC41MVoiIGZpbGw9ImluaGVyaXQiLz4=";